import { useTranslation } from 'react-i18next';
import { z } from 'zod/v3';

import { NumberInput } from '@highlight-cp/core-ui';
import type { NumberInputProps } from '@highlight-cp/core-ui';

const CreditCostInput = (props: NumberInputProps) => {
  const { t } = useTranslation();

  // Credit cost is required (non-nullable). Clearing defaults to 0 per business rules.
  const handleChange = (val: string | number) => {
    const numericValue = val === '' || val === null || val === undefined ? 0 : Number(val);
    if (props.onChange) {
      props.onChange(numericValue);
    }
  };

  const restProps = { ...props };
  delete restProps.onChange;

  return (
    <NumberInput
      label={t('Credit Cost')}
      placeholder="1.5"
      description={t(
        'Enter the credit cost associated with this project. For customers on new pricing (dual currency Highlights + $ Add Ons) enter 0 as credit cost.',
      )}
      decimalScale={2}
      fixedDecimalScale
      step={0.1}
      required
      value={props.value ?? 0}
      onChange={handleChange}
      {...restProps}
    />
  );
};

/**
 * A zod validator for a credit cost.
 * @usage
 * ```ts
 * const form = useForm({
 *   validate: schemaResolver(
 *     z.object({
 *       creditCost: CreditCostInput.zodValidator,
 *     }),
 *     { sync: true },
 *   ),
 * });
 * ```
 * @returns A zod validator for a credit cost.
 */
CreditCostInput.zodValidator = z.number().finite().multipleOf(0.01);

export default CreditCostInput;
